<p-table #defect styleClass="hai-table" [scrollable]="true" scrollHeight="flex" [value]="defects" dataKey="_id" (sortFunction)="onCustomSort($event)" [customSort]="true" [globalFilterFields]="['defectNumber']">
    <ng-template pTemplate="caption">
        <div class="toolbar-right">
            <span class="p-input-icon-left p-ml-auto">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="defect.filterGlobal($any($event.target).value, 'contains')" placeholder="Defect No..." />
            </span>

            <button *ngIf="!readonly" (click)="onAdd()" class="btn btn-add"><i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 120px;" pSortableColumn="defectNumber">
                <p-sortIcon field="defectNumber"></p-sortIcon>Defect No
            </th>
            <th style="width: 120px;">Job / Stage</th>
            <th style="width: 150px;">Raised By</th>
            <th style="width: 150px;" pSortableColumn="raisedAt">
                <p-sortIcon field="raisedAt"></p-sortIcon>Raised Date
            </th>
            <th style="width: 105px;" pSortableColumn="severity">
                <p-sortIcon field="severity"></p-sortIcon>Severity
            </th>
            <th style="width: 180px;">Description</th>
            <th style="width: 150px;">Rectified By</th>
            <th style="width: 150px;" pSortableColumn="rectifiedAt">
                <p-sortIcon field="rectifiedAt"></p-sortIcon>Rectified Date
            </th>
            <th style="width: 105px;" pSortableColumn="resolve">
                <p-sortIcon field="resolve"></p-sortIcon>Resolve
            </th>
            <ng-container *ngIf="!readonly">
                <th style="width: 40px;"></th>
                <th style="width: 40px;"></th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-defect let-columns="columns">
        <tr>
            <td style="width: 120px;" class="defect-number">{{defect?.defectNumber}}</td>
            <td style="width: 120px;">
                <div class="flex-column">
                    {{defect | defectEntityName}}
                    <ng-container *ngIf="defect?.code?._id">
                        <div class="flex-row v-algin-middle"><i class="icomoon icomoon-docs"></i> {{defect?.code?.name}}</div>
                        <div class="flex-row v-algin-middle"><i class="fa fa-map-marker"></i>{{$safeNavigationMigration(defect?.code?.location) | displayText}}</div>
                    </ng-container>
                </div>

            </td>
            <td style="width: 150px;">
                <div class="flex-row flex-v-center">
                    <profile [userId]="$safeNavigationMigration(defect?.raisedBy?._id)" [userName]="$safeNavigationMigration(defect?.raisedBy?.name)"></profile>
                    <span class="txt-black"> {{$safeNavigationMigration(defect?.raisedBy?.name) | displayText}}</span>
                </div>
            </td>
            <td style="width: 150px;">
                <ng-container *ngIf="defect?.raisedAt; else notSet">
                    {{$safeNavigationMigration(defect?.raisedAt) | timezoneDate:$safeNavigationMigration(defect?.timezone)}}
                </ng-container>
            </td>
            <td style="width: 105px;">
                <div class="severity text-center" [ngClass]="$safeNavigationMigration(defect?.severity)"> {{defect?.severity}}</div>
            </td>
            <td style="width: 180px;">{{$safeNavigationMigration(defect?.description) | displayText}}</td>
            <td style="width: 150px;">
                <ng-container *ngIf="!!defect?.rectifiedBy?._id; else notSet">
                    <div class="flex-row flex-v-center">
                        <profile [userId]="$safeNavigationMigration(defect?.rectifiedBy?._id)" [userName]="$safeNavigationMigration(defect?.rectifiedBy?.name)"></profile>
                        <span class="txt-black"> {{defect?.rectifiedBy?.name}} </span>
                    </div>
                </ng-container>
            </td>
            <td style="width: 150px;">
                <ng-container *ngIf="!!defect?.rectifiedAt; else notSet">
                    {{$safeNavigationMigration(defect?.rectifiedAt) | timezoneDate:$safeNavigationMigration(defect?.timezone)}}
                </ng-container>
            </td>
            <td style="width: 105px;">
                <div class="resolve" [ngClass]="{'Yes' : $safeNavigationMigration(defect?.resolve),  'No' : !defect?.resolve}">{{defect?.resolve ? 'Yes' : 'No'}}</div>
            </td>
            <ng-container *ngIf="!readonly">
                <td style="width: 40px;">
                    <div class="actions">
                        <button title="Edit" class="btn btn-glass" (click)="onEdit($safeNavigationMigration(defect?._id))">
                            <i class="fa fa-pencil-square-o"></i>
                        </button>
                    </div>
                </td>
                <td style="width: 40px;">
                    <div class="actions">
                        <button title="Delete" class="btn btn-glass" (click)="onDelete($safeNavigationMigration(defect?._id))">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </td>
            </ng-container>


        </tr>

    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
        <tr class="br-10">
            <td colspan="9">
                <div class="flex-fill empty-message">
                    <empty-message [message]="'No Defects Found.'" [displayIcon]="false" class="empty-result"></empty-message>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<ng-template #notSet>Not Set</ng-template>